import { useEffect, useState } from 'react';
import MESSAGES from '../../../../common/data/constants/messages';
import { ICostCenter } from '../../../../common/data/dtos/coster-center';
import Badge from '../../../../components/bootstrap/Badge';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import { MoreActions } from '../../../../components/extras/MoreActions';
import { showSuccess, showWarning } from '../../../../components/extras/Notifications';
import PaginationButtons, { dataPagination, PER_COUNT } from '../../../../components/PaginationButtons';
import costCenterService from '../../../../services/cost-center-service';
import LoadingPage from '../../loading/LoadingPage';
import { CostCenterModal } from './CostCenterModal';

export const CommonCostCenterList = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['10']);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isModalOpened, setIsModalOpened] = useState(false);

	const [costCenters, setCostCenters] = useState<ICostCenter[]>([]);
	const [selectedCostCenter, setSelectedCostCenter] = useState<ICostCenter | null>(null);

	useEffect(() => {
		fetchCostCenters();
	}, []);

	const fetchCostCenters = async () => {
		setIsLoading(true);

		const response = await costCenterService.getCostCenters();

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		setCostCenters(response.costCenters || []);
	};

	const toggleModal = (isVisible: boolean) => {
		setIsModalOpened(isVisible);
	};

	const handleAddClick = () => {
		toggleModal(true);
	};

	const onModalClose = () => {
		toggleModal(false);
		setSelectedCostCenter(null);
	};

	const onAfterSubmit = async () => {
		await fetchCostCenters();
		onModalClose();
	};

	const handleDeleteClick = async (costCenter: ICostCenter) => {
		if (!costCenter.id) {
			showWarning(MESSAGES.ACTION.DELETE_ID_ERROR);
			return;
		}

		setIsLoading(true);

		const response = await costCenterService.deleteCostCenter(costCenter.id);

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		showSuccess(MESSAGES.ACTION.DELETED);
		await fetchCostCenters();
	};

	const handleEditClick = (costCenter: ICostCenter) => {
		setSelectedCostCenter(costCenter);
		toggleModal(true);
	};

	if (isLoading) {
		return <LoadingPage />;
	}
	return (
		<>
			<Card style={{ minHeight: 600 }}>
				<CardHeader borderSize={1}>
					<CardLabel icon='Store' iconColor='primary'>
						<CardTitle tag='div' className='h5'>
							Centros de custo
						</CardTitle>
					</CardLabel>
					<CardActions>
						<Button color='light' icon='AddCircle' onClick={handleAddClick}>
							Adicionar
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody className='table-responsive'>
					<table className='table table-modern table-hover'>
						<thead>
							<tr>
								<th>Descrição</th>
								<th>Situação</th>
								<td aria-labelledby='Actions' />
							</tr>
						</thead>
						<tbody>
							{dataPagination(costCenters, currentPage, perPage).map((item: ICostCenter) => (
								<tr key={item.id}>
									<td>{item.description}</td>
									<td>
										{item.status ? (
											<h5>
												<Badge color='success' className='align-items-center justify-content-center'>
													Ativo
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='danger' className='align-items-center justify-content-center'>
													Inativo
												</Badge>
											</h5>
										)}
									</td>

									<MoreActions id={item.id} showEdit={true} showDelete={true} onEditClick={() => handleEditClick(item)} onDeleteClick={() => handleDeleteClick(item)} />
								</tr>
							))}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons data={costCenters} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
			</Card>

			<CostCenterModal isModalOpened={isModalOpened} onModalClose={onModalClose} onAfterSubmit={onAfterSubmit} selectedCostCenter={selectedCostCenter} />
		</>
	);
};
